import { types, flow } from 'mobx-state-tree';
import { pick } from 'lodash';
import { castEventToValue } from 'js/services/FormTools';
import { makeRequest } from 'js/services/Network';
import { formatCurrency } from 'js/services/Format';
import analytics from 'js/services/Analytics';

export default types
  .model('EditTokenForm', {
    requestInProgress: false,
    error: types.maybeNull(types.string),
    alias: types.string,
    title: types.string,
    price: types.union(types.number, types.string),
  })
  .actions(self => ({
    afterCreate() {
      self.price = formatCurrency(self.price);
    },
    save: flow(function* save() {
      if (!self.requestInProgress) {
        self.requestInProgress = true;
        self.error = null;

        try {
          yield makeRequest('save-token', self, pick(self, ['title', 'price']));
          //yield analytics.track('token saved');
        } catch (error) {
          self.requestInProgress = false;
          self.error = error.response.data.message || error.response.statusText;
          throw error;
        }

        self.requestInProgress = false;
      }
      return pick(self, ['title', 'price']);
    }),
    setTitle(title) {
      self.title = castEventToValue(title);
      return self;
    },
    setPrice(price) {
      self.price = castEventToValue(price);
      return self;
    },
  }));
